<script>
import { mapGetters, mapState, mapActions } from 'vuex';
import store from '../../../../store';
import TwTitleBar from '../../../../components/TwTitleBar';

export default {
  name: 'SkiSchool',
  props: {
    bookingId: {
      type: [Number, String],
    },
  },
  data() {
    return {
      currentBookingId: this.bookingId,
      activeTab: `/booking/${this.bookingId}/ski/school/overview`,
      tabs: [
        {
          id: 1,
          name: this.$t('ski.school.tabHeaders.overview'),
          route: '/booking/:bookingId/ski/school/overview',
          total: 0,
          showTotal: true,
          disabled: false,
        },
        {
          id: 2,
          name: this.$t('ski.school.tabHeaders.availableProducts'),
          route: '/booking/:bookingId/ski/school/available-products',
          total: 0,
          showTotal: false,
          disabled: false,
        },
      ],
      tabMenuOverview: 1,
    };
  },
  components: {
    TwTitleBar,
  },
  computed: {
    ...mapGetters({
      totalNumberOfSkiSchoolProducts: 'skischool/getTotalNumberOfSkiSchoolProducts',
    }),
    ...mapState({
      booking: state => state.booking.booking,
    }),
    breadcrumbs() {
      return [
        { text: this.$t('menu.booking.pages.ski.title'), to: '', disabled: true },
        { text: this.$t('menu.booking.pages.ski.school.title'), to: { name: 'SkiSchool' } },
        { text: this.$t(`breadcrumbs.${this.$route.name}`), to: this.$route.path },
      ];
    },
    schoolsMenu() {
      const tabs = this.tabs;
      if (!this.currentBookingId) {
        return tabs;
      }
      const selectedBooking = this.booking;
      if (selectedBooking) {
        for (let i = 0; i < tabs.length; i += 1) {
          tabs[i].disabled = false;
          tabs[i].route = tabs[i].route.replace(':bookingId', this.currentBookingId);
          if (tabs[i].id === this.tabMenuOverview) {
            tabs[i].total = this.totalNumberOfSkiSchoolProducts;
          }
        }
      }

      return tabs;
    },
  },
  methods: {
    ...mapActions({
      loadBookingStayParticipantsByStayIds: 'booking/bookingStayParticipantsByBookingStayIds',
    }),
  },
  mounted() {
    if (this.booking !== undefined && this.booking.id) {
      const bookingStayIds = this.booking.stays.map(stay => stay.id);
      this.loadBookingStayParticipantsByStayIds(bookingStayIds);
    }
  },
  beforeRouteEnter(to, from, next) {
    if (to.params.bookingId) {
      store.dispatch('skischool/schoolsByBookingIdLoad', to.params.bookingId)
        .finally(() => {
          next();
        });
    }
  },
};
</script>
<template>
  <v-container v-if="booking && booking.id" fluid>
    <tw-title-bar
      :title="$t('menu.booking.skiSchoolTitleWithArea')"
      :breadcrumbs="breadcrumbs"
      :booking-info="booking"
    >
    </tw-title-bar>
    <v-layout class="pt-0" row wrap>
      <v-flex class="pr-12" grow>
        <v-tabs
          v-model="activeTab"
          mandatory
          align-with-title
          grow
          fixed-tabs
        >
          <v-tab
            v-for="tab in schoolsMenu"
            v-bind="tab"
            :key="tab.id"
            :to="{ path: tab.route }"
            :disabled="tab.disabled"
            exact
          >
            {{ tab.name }}
            <span v-if="tab.showTotal" class="ml-1">
              ({{ tab.total }})
            </span>
          </v-tab>
          <v-tabs-items>
            <v-tab-item
              v-for="tab of tabs"
              :transition="false"
              :reverse-transition="false"
              :key="tab.id"
              :value="tab.route"
            >
            </v-tab-item>
          </v-tabs-items>
        </v-tabs>
        <router-view></router-view>
      </v-flex>
    </v-layout>
  </v-container>
</template>



// WEBPACK FOOTER //
// src/pages/booking/ski/school/SkiSchool.vue